/**
 * app router
 */
import Vue from 'vue'
import Router from 'vue-router'

// you should change your routes
import routes from './view/topic/routes'

Vue.use(Router)
const router = new Router({
  routes
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router
